import { getToken } from '@/utils/auth'
import service from '@/utils/request'
import util from '@/utils'

/** 获取订单列表 */
export function getOrderList(params) {
  return service.get('/backend/order/list', { params })
}

/** 统计订单数 */
export function getOrderCount(params) {
  return service.get('/backend/order/count', { params })
}

/** 批量导出订单列表到Excel */
export function orderExport(params) {
  // return service.get('/backend/order/export', { params })
  return `${process.env.VUE_APP_BASE_API}/backend/order/export?X-Access-Token=${getToken()}&${util.json2UrlParam(params)}`
}

/** 导入物流列表 */
export function orderImport(params) {
  return service.post('/backend/order/import', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 120000 // 设置超时2分钟
  })
}

/** 订单发货 */
export function orderShipment(data) {
  return service.post(`/backend/order/shipment`, data)
}

/** 获取订单操作记录 */
export function getOrderRecords(orderId) {
  return service.get(`/backend/order/${orderId}/log`)
}

/** 订单核销 */
export function orderVerify(data) {
  return service.post(`/backend/order/verification`, data)
}

/** 设置订单为自提 */
export function resetDeliveryMethod(orderId) {
  return service.post(`/backend/order/deliverymethod?orderNumber=${orderId}`)
}

/** 订单退款原因列表 */
export function getRefundReasonList() {
  return service.get(`/backend/order/refund/reason/list`)
}

/** 订单退款列表 */
export function getRefundList(params) {
  return service.get(`/backend/order/refund/list`, { params })
}

/** 统计订单退款数 */
export function getRefundCount(params) {
  return service.get('/backend/order/refund/count', { params })
}

/** 订单退款详情 */
export function getRefundDetail(orderNumber) {
  return service.get(`/backend/order/refund/detail?orderNumber=${orderNumber}`)
}

/** 订单退款审核 */
export function refundReview(data) {
  return service.post(`/backend/order/refund/detail`, data)
}

/** 后台申请退款 */
export function refundApply(data) {
  return service.post(`/backend/order/refund/apply`, data)
}
